import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#0B1412]" data-id="element-786" data-mp="3ghc3g4fxp7pa">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-787" data-mp="32lrlbb814tix">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-788" data-mp="36q94p9ah94t6">
          <div className="md:col-span-2" data-id="element-789" data-mp="3ugbqj7nstejc">
            <Link to="/" className="inline-block mb-4" data-id="element-790" data-mp="3ud7czjog16g0">
              {/* Footer uses the green "206" mark directly rather than the shared
                  Logo component, which is a white wordmark intended for the
                  navbar's light/dark inversion. */}
              <img src="https://cdn.magicpatterns.com/uploads/dG7cTe4zHjJ7aNpipr3v1U/206_Green.png" alt="206Gravel" className="h-10 w-auto block" data-id="element-791" data-mp="3qblvtm4vm600" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-792" data-mp="2eyjprl0ekyu3">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-793" data-mp="3lbdces4h47la">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-794" data-mp="3gapbneqg0cdv">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-795" data-mp="3v7zuj95f0kjm">
              <li data-id="element-796" data-mp="3q8wphopfqebn">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-797" data-mp="3q8dih31bpace">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-798" data-mp="33xdnwzdzwrz">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-799" data-mp="34gvldp1el60">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-800" data-mp="ctqouwvma9vp">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-801" data-mp="cuikg7p7s7lz">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-802" data-mp="cw33p162w44j">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-803" data-mp="mrwqdddihe01">
              <li data-id="element-804" data-mp="mtr86ithkpzw"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-805" data-mp="mptq80ina4hl">Base &amp; Compaction</Link></li>
              <li data-id="element-806" data-mp="ytekkiej0et9"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-807" data-mp="yv93xsa5fyv8">Clear &amp; Drain</Link></li>
              <li data-id="element-808" data-mp="13r7nn2kj8spb"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-809" data-mp="13rfzqs8tztzg">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-810" data-mp="1ckt0uhh1u1wm"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-811" data-mp="1ckt2elwp69yq">Quarry Rock</Link></li>
              <li data-id="element-812" data-mp="1hms2nmx54qrg"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-813" data-mp="1hmie83rqurnv">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-814" data-mp="1ri3jqbw0ua2d">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-815" data-mp="1rgir4rt9p175">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-816" data-mp="3t9q6204yxgsi">
              <li data-id="element-817" data-mp="2af3r7lrdkvhi">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-818" data-mp="2afnbh94hzvyp">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-819" data-mp="25mkd8norzyc6">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-820" data-mp="21mjy10turj42">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-821" data-mp="1wlw2q2ylcg41">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-822" data-mp="2tdpwzdxu7arr">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-823" data-mp="2pajn7wbin1gj">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-824" data-mp="2kd1i6h0md6dt">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-825" data-mp="2fgb0jp9622qa">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-826" data-mp="18y4mwpdudky0">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-827" data-mp="13xqfn9k2ef11">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-828" data-mp="141e7835y8rd4">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-829" data-mp="2iv1i6u4j9wal">
          <p data-id="element-830" data-mp="2ntmietjscfz1">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-831" data-mp="3bjgs528t5of2">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-832" data-mp="3bhm4hg65ji7a">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-833" data-mp="31m2d972j97ov">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-834" data-mp="36isqznqv7r74">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#000000]" data-id="element-835" data-mp="1in4nx6f6xa8i">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide bg-[#000000]" data-id="element-836" data-mp="1imcthyxbxijt">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[700] text-[#57534e]" data-id="element-837" data-mp="13xozvy71niwi">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-838" data-mp="zy7x5cj04zv1">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-839" data-mp="18w9sbbg20yae">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-840" data-mp="g95t5n3n7e6j">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}